import { Box } from '@mui/material'
import React, { useState } from 'react'

const ImageUploader = ({
  onLogoUpload,
  uploadLabel = 'UPLOAD LOGO',
  chooseFileLabel = 'Choose File',
  logoLabel = '',
  noFileChosenLabel = 'No File Chosen',
  chooseFileBorder = '1px solid #0086ff',
  logoFile = null,
}) => {
  return (
    <Box style={{ display: 'flex', borderRadius: '6px', padding: '0' }}>
      <div style={{ padding: '0' }} className={'input--wrapper'}>
        <label
          id={'chooseLogo'}
          htmlFor="inputfile123"
          style={{
            display: 'flex',
            alignItems:'center',
            height: '40px',
            border: chooseFileBorder,
            padding: '0 10px',
            position: 'relative',
            borderRadius: '6px',
            backgroundColor: 'white',
            whiteSpace:'nowrap'
          }}
        >
          {logoLabel&&<span style={{ position: 'absolute', left: '14px', top: '-8px', background: 'white', padding: '4px' }}>{logoLabel} </span>}
          <span style={{ fontFamily: 'Roboto', fontSize: '16px', color: '#444444', fontWeight: '400' }}>{chooseFileLabel}</span>
        </label>

        <input
          id="inputfile123"
          type="file"
          onChange={(e) => {
            onLogoUpload(e)
          }}
          style={{ display: 'none' }}
        ></input>
      </div>

      {!logoFile && (
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            fontWeight: '500',
            fontFamily: 'Roboto',
            color: '#0086FF',
            marginLeft:'10px',
          }}
        >
          {noFileChosenLabel}
        </label>
      )}

      {logoFile && <img src={logoFile} alt="Logo Preview" style={{ maxWidth: '100%', maxHeight: '50px', marginLeft: '10px',marginBottom:'5px' }} />}
    </Box>
  )
}

export default ImageUploader
